import { render } from "./ProjectsProtocol.vue?vue&type=template&id=5ae23483&scoped=true"
import script from "./ProjectsProtocol.vue?vue&type=script&lang=js"
export * from "./ProjectsProtocol.vue?vue&type=script&lang=js"

import "./ProjectsProtocol.vue?vue&type=style&index=0&id=5ae23483&lang=css"
import "./ProjectsProtocol.vue?vue&type=style&index=1&id=5ae23483&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ae23483"]])

export default __exports__